import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { DebriefReviewStep } from '@/features/wizard/components/DebriefReviewStep';
import { useGetDebrief } from '@/shared/hooks/useInteractions';
import { useEmployees } from '@/shared/hooks/useEmployees';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/shared/components/ui/Button';

export const Route = createFileRoute('/_dashboard/interactions/debrief/$id')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('common');
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { data: debrief, isLoading } = useGetDebrief(id);
  const { data: employees } = useEmployees({ isActive: true });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-muted-foreground">Loading debrief...</p>
        </div>
      </div>
    );
  }

  if (!debrief || !employees) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-muted-foreground">{t('notFound')('Debrief')}</p>
          <Button
            variant="outline"
            onClick={() => navigate({ to: '/' })}
            className="mt-4"
          >
            {t('goBack')}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-8">
      <Button
        variant="ghost"
        onClick={() => navigate({ to: '/' })}
        className="mb-6 gap-2"
      >
        <ArrowLeft className="h-4 w-4" />
        {t('backToInteractions')}
      </Button>

      <DebriefReviewStep
        answers={{}}
        employees={employees}
        isSubmitting={false}
        existingDebrief={debrief}
      />
    </div>
  );
}
